import styled from '@emotion/styled';

export const ChatOrderModalStyle = styled.div`
  position: relative;
  padding: 24px;
  width: 476px;
  border-radius: 16px;
  background-color: var(--seed-semantic-color-paper-default);

  .close-button {
    position: absolute;
    top: 14px;
    right: 20px;
    padding: 3px;
    border: none;
    background: none;
    cursor: pointer;
    color: var(--seed-scale-color-gray-600);
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      color: var(--seed-scale-color-gray-900);
      fill: var(--seed-scale-color-gray-900);
    }

    svg{
      fill: var(--seed-scale-color-gray-600);
    }
  }

  .title {
    font-size: 24px;
    font-weight: 700;
    margin-bottom: 12px;
    color: var(--seed-scale-color-gray-900);
  }

  .customer-divider {
    width: 100%;
    height: 1px;
    background-color: var(--seed-semantic-color-divider-1);
    margin-bottom: 16px;
  }

  .customer-section {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;

    .customer-label {
      font-size: 14px;
      color: var(--seed-scale-color-gray-600);
    }

    .customer-name {
      font-size: 14px;
      font-weight: 500;
      color: var(--seed-scale-color-gray-900);
    }
  }
`;
